import React from 'react';
import { motion } from 'framer-motion';
import { SquareArrowOutUpRight, Table2 } from 'lucide-react';

interface SpreadsheetContentProps {
  onExpand: () => void;
}

export const SpreadsheetContent: React.FC<SpreadsheetContentProps> = ({ onExpand }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="bg-muted/50 border border-muted rounded-xl p-8 shadow-sm max-w-xl mx-auto flex flex-col items-center">
        <div className="bg-primary/10 p-5 rounded-full mb-5">
          <SquareArrowOutUpRight size={40} className="text-primary" />
        </div>
        <p className="text-center text-muted-foreground mb-6">
          This document contains tabular data that can be better viewed in spreadsheet format.
        </p>
        <motion.button
          onClick={onExpand}
          className="flex items-center border border-border rounded-md bg-background px-5 py-2.5 text-sm font-medium hover: transition-colors"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
        >
          <span className='flex items-center gap-2'>
            <Table2 size={18} /> View Spreadsheet
          </span>
        </motion.button>
      </div>
    </div>
  );
};